import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FlecheEnvoiClair from '../../assets/fleche_envoi_clair.png';
import styled from 'styled-components';
import theme from '../../theme';
import {
  Container,
  ContentWrapper,
  ReturnButton,
  SubmitButton,
  LogoImage,
  ChatBubbleContainer,
  ChatText,
  OptionsContainer,
  ButtonsWrapper,
  OptionButton,
  OptionIcon,
  LoadingOverlay,
  LogoBubbleWrapper
} from './styles';
import ProgressBar from '../ProgressBar';

// Placeholder Icons - Replace with actual imports
import searchIcon from '../../assets/loupe_menu.png'; // Placeholder
// import foundIcon from '../../assets/check_icon.png'; // Old placeholder
import trueIcon from '../../assets/true_icon.png'; // Use the correct icon
import compassImage from '../../assets/meo_write.png';

// New wrapper to center the options block
const OptionsCenteringWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center; /* Vertical centering */
  align-items: center;   /* Horizontal centering (for the container itself) */
  flex-grow: 1;          /* Take available vertical space */
  width: 100%;
  padding-bottom: 100px; /* Add padding to avoid overlap with fixed submit button */
`;

const Choice = () => {
  const navigate = useNavigate();
  const [selectedChoice, setSelectedChoice] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // If any async operation needed later
  const [isTyping, setIsTyping] = useState(true);
  const [text, setText] = useState('');
  const [fullText, setFullText] = useState(''); // Initialize with empty string
  const [activeOption, setActiveOption] = useState(null);
  const [submitActive, setSubmitActive] = useState(false);

  useEffect(() => {
    const pseudo = localStorage.getItem('pseudo') || 'toi'; // Fallback if pseudo is not found
    setFullText(`Hello ${pseudo}, où en es-tu ?`);
  }, []);

  useEffect(() => {
    if (!fullText) return; // Don't start typing if fullText isn't set yet

    let currentIndex = 0;
    const typingInterval = setInterval(() => {
      if (currentIndex <= fullText.length) {
        setText(fullText.slice(0, currentIndex));
        currentIndex++;
      } else {
        setIsTyping(false);
        clearInterval(typingInterval);
      }
    }, 15);
    return () => clearInterval(typingInterval);
  }, [fullText]);

  const choiceOptions = [
    { value: 'cherche', label: 'Je cherche une formation', icon: searchIcon },
    // { value: 'trouve', label: 'J\'ai déjà trouvé !', icon: foundIcon }, // Old usage
    { value: 'trouve', label: 'J\'ai déjà trouvé !', icon: trueIcon }, // Updated usage
  ];

  const handleOptionClick = (option) => {
    setSelectedChoice(option.value);
  };

  const handleSubmit = () => {
    if (!selectedChoice || isTyping) return;
    localStorage.setItem('onboardingChoice', selectedChoice);
    localStorage.setItem('search_a_school', selectedChoice === 'cherche');
    // navigate('/pseudo'); // Old navigation

    // New conditional navigation
    if (selectedChoice === 'cherche') {
      navigate('/user-type-selection');
    } else if (selectedChoice === 'trouve') {
      localStorage.setItem('type_utilisateur', 'student'); // Set user type to student
      navigate('/bac1'); // Route for FormationOnboarding
    } else {
      // Fallback (shouldn't happen if selection is required)
      navigate('/user-type-selection');
    }
  };

  const handleBack = () => {
    // navigate('/presentation-meo'); // Old back navigation
    navigate('/pseudo'); // Go back to Pseudo
  };

  // Pointer Handlers for Button Press Effect
  const handleSubmitPressStart = () => {
    if (isLoading || isTyping || !selectedChoice) return;
    setSubmitActive(true);
  };

  const handleSubmitPressEnd = () => {
    if (isLoading || isTyping || !selectedChoice) return;
    setSubmitActive(false);
    setTimeout(() => {
      handleSubmit();
    }, 150);
  };

  return (
    <Container>
      {isLoading && <LoadingOverlay isLoading={isLoading} />}
      <ReturnButton onClick={handleBack}>
        <img src={FlecheEnvoiClair} alt="Back" style={{ width: '24px', height: '24px' }} />
      </ReturnButton>
      <ContentWrapper>
        <ProgressBar startPercent={10} endPercent={15} />
        <LogoBubbleWrapper>
          <LogoImage src={compassImage} alt="Compass Logo" />
          <ChatBubbleContainer> {/* Removed isMobile prop if not used in style */}
            <ChatText isVisible={text.length > 0}>
              <span>{text}</span>
            </ChatText>
          </ChatBubbleContainer>
        </LogoBubbleWrapper>

        {/* New Centering Wrapper */}
        <OptionsCenteringWrapper>
          {/* Existing Options Container */}
          <OptionsContainer>
            <ButtonsWrapper style={{
              opacity: isTyping ? 0 : 1,
              transition: 'opacity 0.3s ease',
              pointerEvents: isTyping ? 'none' : 'auto'
            }}>
              {choiceOptions.map((option) => (
                <OptionButton
                  key={option.value}
                  $isSelected={selectedChoice === option.value}
                  type="button"
                  aria-pressed={selectedChoice === option.value}
                  onMouseDown={() => setActiveOption(option.value)}
                  onMouseUp={() => { setActiveOption(null); handleOptionClick(option); }}
                  onMouseLeave={() => setActiveOption(null)}
                  onTouchStart={() => setActiveOption(option.value)}
                  onTouchEnd={() => { setActiveOption(null); handleOptionClick(option); }}
                  active={activeOption === option.value}
                >
                  <OptionIcon
                    src={option.icon}
                    alt=""
                    $isSelected={selectedChoice === option.value}
                  />
                  {option.label}
                </OptionButton>
              ))}
            </ButtonsWrapper>
          </OptionsContainer>
        </OptionsCenteringWrapper>
        {/* End New Centering Wrapper */}

        <SubmitButton
          type="button"
          disabled={isLoading || isTyping || !selectedChoice}
          style={{ cursor: (isTyping || !selectedChoice) ? 'not-allowed' : 'pointer' }}
          onMouseDown={handleSubmitPressStart}
          onMouseUp={handleSubmitPressEnd}
          onMouseLeave={() => setSubmitActive(false)}
          onTouchStart={handleSubmitPressStart}
          onTouchEnd={handleSubmitPressEnd}
          active={submitActive}
        >
          {isLoading ? 'Chargement...' : 'Continuer'}
        </SubmitButton>
      </ContentWrapper>
    </Container>
  );
};

export default Choice; 